export default function (callback, timeout) {
  //小程序下支持requestIdleCallback，但没有window，不能通过window.requestIdleCallback判断
  if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(callback, {
      timeout: timeout || 1000
    });
  } else {
    setTimeout(callback, 0);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-longtask@1.0.1@@ali/aes-tracker-plugin-longtask/es/utils/requestIdleCallback.js
// module id = null
// module chunks = 